module.exports = __webpack_public_path__ + "static/media/discord.5f33a495.svg";